module.exports = __webpack_public_path__ + "img/Asset-52.4772c70a.png";